export const FETCH_ME_ACCEPT_TERM = 'FETCH_ME_ACCEPT_TERM'
export const RECEIVE_ME_ACCEPT_TERM = 'RECEIVE_ME_ACCEPT_TERM'
